import { z } from 'zod';

export const basicInfoSchema = z.object({
  name: z.string().min(1, { message: 'Required' }).max(200),
  description: z.string(),
  categoryId: z.string().min(1, { message: 'Required' }).uuid()
});

export const getLocationDetailsSchema = (isLocationRequired) =>
  z.object({
    regionId: z.string().min(1, { message: 'Required' }),
    locationId: isLocationRequired
      ? z.string().min(1, { message: 'Required' })
      : z.string().nullable(),
    isMeetingSpot: z.boolean(),
    locationName: z.string().max(200).optional(),
    locationDetails: z.string().max(500).optional(),
    meetingLat: z.number().optional(),
    meetingLng: z.number().optional()
  });

export const offeringDetailsSchema = z.object({
  length: z.number({ message: 'Duration is required' }).int().positive(),
  requirements: z.string().optional(),
  includedItems: z.string().optional(),
  notIncludedItems: z.string().optional()
});

export const pricingAndBookingSchema = z.object({
  pricePerClient: z
    .string()
    .refine(
      (val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0,
      'Must be a valid positive number'
    ),
  currency: z.string().min(1, { message: 'Currency is required' }),
  isGroup: z.boolean(),
  maxGroupClients: z.number().optional(),
  bookingLeadTime: z.number().min(0, { message: 'Lead time must be positive' })
});
